import {DomainEvent} from './DomainEvent';
import {Match} from '../resources/Match';

export class MatchAborted extends DomainEvent<Match> {}

export class RefreshMatchAborted extends MatchAborted {}
